import { render, staticRenderFns } from "./LiveOrderCount.vue?vue&type=template&id=ca26ff20&"
import script from "./LiveOrderCount.vue?vue&type=script&lang=js&"
export * from "./LiveOrderCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports